<template>
  <v-dialog v-model="show" max-width="440" persistent>
    <v-card class="popup add_store_popup popup-success vne-modal">
      <i class="ico-success"
          ><img src="@/assets/img/ico-caution.png" alt=""
        /></i>

      <div class="msg">
        <h3 class="mb-1 vne-title">{{ $t('Vision Not Enabled') }}</h3>
        <p v-if="storeName || storeCode" class="vne-store-label">
          {{ storeName }}<span v-if="storeCode"> &middot; {{ storeCode }}</span>
        </p>
      </div>

      <v-divider class="vne-divider" />

      <v-row class="mt-3 mb-1">
        <v-col class="py-0 text-center">
          <span class="vne-message">
            {{ $t('Vision is not enabled for this store. Please go to Store Settings to enable the Vision configuration.') }}
          </span>
        </v-col>
      </v-row>

      <v-row class="pt-3">
        <v-col class="py-0">
          <div class="vne-note">
            <v-icon small color="#e65100" class="mr-1" style="vertical-align:middle;">mdi-information-outline</v-icon>
            <span>{{ $t('Cancelling will redirect you to the Overview page.') }}</span>
          </div>
        </v-col>
      </v-row>

      <v-card-actions class="d-flex justify-center mt-6">
        <v-btn text class="btn vne-btn-primary" @click="onGoToStoreSettings">
          {{ $t('Store Settings') }}
        </v-btn>
        <v-btn text class="btn vne-btn-cancel" @click="onCancel">
          {{ $t('Cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'VisionNotEnabledModal',
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    storeName: {
      type: String,
      default: ''
    },
    storeCode: {
      type: String,
      default: ''
    }
  },
  computed: {
    show: {
      get () { return this.visible },
      set (val) { this.$emit('input', val) }
    }
  },
  methods: {
    onGoToStoreSettings () {
      this.$store.dispatch('dataStore/updateShowVisionModal', false)
      this.$emit('input', false)
      this.$router.push('/Store/StoreInfo').catch(() => {})
    },
    onCancel () {
      this.$store.dispatch('dataStore/updateShowVisionModal', false)
      this.$emit('input', false)
      this.$router.push('/').catch(() => {})
    }
  }
}
</script>

<style scoped>
/* Slightly wider padding and softer shadow vs base popup */
.vne-modal {
  border-radius: 10px !important;
  box-shadow: 0 10px 40px rgba(0, 30, 56, 0.2) !important;
  padding: 44px 56px 40px !important;
}

/* Camera icon circle uses project primary instead of grey */
.vne-icon {
  background: #001e38 !important;
}

.vne-title {
  font-size: 22px !important;
  color: #001e38;
  font-weight: 500;
}

.vne-store-label {
  font-size: 12px;
  color: #adb7bf;
  margin: 2px 0 0;
  line-height: 1.4;
}

.vne-divider {
  margin: 24px 0 0;
  border-color: #f0f0f0 !important;
}

.vne-message {
  font-size: 14px;
  color: #2d3748;
  line-height: 1.7;
}

.vne-note {
  background: #fff3e0;
  border: 1px solid #ffb74d;
  border-left: 4px solid #e65100;
  border-radius: 6px;
  padding: 9px 12px;
  font-size: 12px;
  color: #5d3b00;
  text-align: left;
  line-height: 1.5;
  display: flex;
  align-items: flex-start;
}

/* Primary action — solid dark */
.vne-btn-primary.v-btn .v-btn__content {
  background: #001e38 !important;
  color: #fff !important;
}

/* Cancel — outlined style */
.vne-btn-cancel.v-btn .v-btn__content {
  background: transparent !important;
  color: #001e38 !important;
  border-color: #adb7bf !important;
}
</style>
